type Context = 'crm-agents';

type Section = 'list' | 'agent' | 'enrichment-history';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  list: 'crm-agents-list',
  agent: 'crm-agents-agent',
  'enrichment-history': 'crm-agents-enrichment-history',
};
